<app-CheckBuilder [routePrefix]="'/anagrafica/categorie/check'"></app-CheckBuilder>
